// @flow

import styled from 'styled-components';
import { LinkStyled } from '../../../link';
import type { Theme } from '../../../../types';

const StyledActiveLink = styled<typeof LinkStyled, Theme>(LinkStyled)`
  &,
  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: ${props => props.theme.faq.subCategoryList.activeItem.color};
    font-weight: ${props => props.theme.faq.subCategoryList.activeItem.fontWeight};
  }
`;

export default StyledActiveLink;
